export type PurchaseHubLocationState = {
  returnTo?: string;
  returnToPreview?: boolean;
  /** Pay overlay opened from bill preview — close returns to this bill view. */
  previewBillId?: number;
  transactionId?: number;
  showVoid?: boolean;
  vendorId?: number;
  billId?: number;
};

export const parsePurchaseHubLocationState = (state: unknown): PurchaseHubLocationState | null =>
  (state as PurchaseHubLocationState | null) ?? null;

export const purchaseHubListTarget = (listSearch: string) => ({
  pathname: '/purchase-transactions' as const,
  search: listSearch,
});

export const purchaseBillPreviewTarget = (
  billId: number,
  listSearch: string,
  transactionId?: number
) => ({
  pathname: `/purchase-transactions/view/bill/${billId}` as const,
  search: listSearch,
  state: transactionId != null ? { transactionId } : undefined,
});

export const purchasePaymentPreviewTarget = (
  paymentId: number,
  listSearch: string,
  transactionId?: number,
  returnTo?: string
) => ({
  pathname: `/purchase-transactions/view/payment/${paymentId}` as const,
  search: listSearch,
  state:
    returnTo || transactionId != null
      ? {
          ...(returnTo ? { returnTo } : {}),
          ...(transactionId != null ? { transactionId } : {}),
        }
      : undefined,
});

export const resolveBillOverlayCloseTarget = (
  billId: number | undefined,
  listSearch: string,
  navState: PurchaseHubLocationState | null
) => {
  if (navState?.returnToPreview && billId) {
    return purchaseBillPreviewTarget(billId, listSearch, navState.transactionId);
  }
  return purchaseHubListTarget(listSearch);
};

export const resolvePaymentAllocationsCloseTarget = (
  paymentId: number | undefined,
  listSearch: string,
  navState: PurchaseHubLocationState | null
) => {
  if (navState?.returnToPreview && paymentId) {
    return purchasePaymentPreviewTarget(
      paymentId,
      listSearch,
      navState.transactionId,
      navState.returnTo
    );
  }
  return purchaseHubListTarget(listSearch);
};

export const resolvePayBillOverlayCloseTarget = (
  listSearch: string,
  navState: PurchaseHubLocationState | null
) => {
  if (navState?.returnToPreview && navState.previewBillId) {
    return purchaseBillPreviewTarget(navState.previewBillId, listSearch, navState.transactionId);
  }
  return purchaseHubListTarget(listSearch);
};

export const billEditFromPreviewState = (transactionId?: number): PurchaseHubLocationState => ({
  returnToPreview: true,
  transactionId,
});

export const paymentEditFromPreviewState = (
  transactionId?: number,
  returnTo?: string
): PurchaseHubLocationState => ({
  returnToPreview: true,
  transactionId,
  returnTo,
});

export const payBillFromPreviewState = (
  vendorId: number,
  billId: number,
  transactionId?: number
): PurchaseHubLocationState => ({
  returnToPreview: true,
  previewBillId: billId,
  vendorId,
  billId,
  transactionId,
});
